import React from 'react';
import PropTypes from 'prop-types';
import TableReport from '@componentes/TableReport';
import Table from './Table';
import IntlMessage from '../../../../helpers/intlMessage';

function ImpressaoLaminasCitologia ({lista}) {
  return (
    <TableReport
      title={<IntlMessage id = "dashboards.taskControl.titleReportCitologySlides"/>}
      assinatura={<IntlMessage id = "dashboards.reports.subscriptionCRM"/>}
      children={lista}
    >
      {lista.map((item, i) => (
        <tr key={i} style={{border: 0}} className='relatorio-controle-laminas-citologia'>
          <td style={{border: 0, padding: 0}}>
            <Table item={item}/>
          </td>
        </tr>
      ))}
    </TableReport>
  );
}

ImpressaoLaminasCitologia.propTypes = {
  lista: PropTypes.array.isRequired
};

ImpressaoLaminasCitologia.defaultProps = {
  lista: []
};

export default ImpressaoLaminasCitologia;



// WEBPACK FOOTER //
// ./src/pages/controleTarefas/Citologia/Impressao/index.js